import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { NgxSpinnerService } from 'ngx-spinner';
import { BehaviorSubject, Observable } from 'rxjs';
import { SearchParams } from 'src/app/shared/models/searchParams';
import { environment } from 'src/environments/environment';
import { ApiBaseService } from '../api/api-base.service';
import { ChatApiService } from '../api/chat-api.service';
import { ChatService } from '../chat.service';
import { ErrorService } from '../error/error.service';
import { UserStateService } from '../user/user-state.service';

@Injectable({
  providedIn: 'root'
})
export class FcmService extends ApiBaseService {

  currentMessage = new BehaviorSubject(null);

  baseUrl = environment.backend_host + '/api';

  constructor(
    private angularFireMessaging: AngularFireMessaging,
    public http: HttpClient,
    protected errorService: ErrorService,
    protected spinner: NgxSpinnerService,
    protected userState: UserStateService,
    private chatService: ChatService,
    private chatApi: ChatApiService
  ) {
    super(spinner, errorService);
    this.angularFireMessaging.messages.subscribe((_messaging: AngularFireMessaging) => {
      _messaging.onMessage = _messaging.onMessage.bind(_messaging);
      _messaging.onTokenRefresh = _messaging.onTokenRefresh.bind(_messaging);
    });
  }

  registerDevice = (token): Observable<any> =>
    this.http.post<any>(`${this.baseUrl}/devices`, {
      registration_id: token,
      type: 'web'
    });

  requestPermission() {
    this.angularFireMessaging.getToken.subscribe((token) => {
      localStorage.setItem('browserRegistered', 'true');
      this.registerDevice(token).subscribe();
    }, (err) => {
      console.error('Unable to get permission to notify.', err);
    });
  }

  receiveMessage() {
    this.angularFireMessaging.messages.subscribe((payload) => {
      console.log('new message received. ', payload);
      this.currentMessage.next(payload);
      this.showCustomeNotification(payload);
      this.chatService.updateChatList(new SearchParams());
    });

  }


  showCustomeNotification(payload: any) {
    let notify_data = payload['notification'];
    let title = notify_data['title'];
    console.log(payload);

    let options = {
      body: notify_data['body'],
      icon: "favicon.ico",
      badge: "favicon.ico",
      image: "favicon.ico"
    }
    let notify: Notification = new Notification(title, options);
    notify.onclick = event => {
      event.preventDefault();
      window.location.href = `http://localhost:4200/chat`
    }
  }

}
